import { createFileRoute } from "@tanstack/react-router";
import { ServicesPage } from "@/components/services/services-page";

export const Route = createFileRoute("/_app/services")({
  component: ServicesPage,
});
